module.exports = __webpack_public_path__ + "static/media/CountryHappiness.ce5697cd.gif";